import { Modal } from 'antd';
import io from 'socket.io-client';

let add = '';
export const readBySs = (readPort, mode, callback) =>{
    if(!readPort || typeof (readPort) == "undefined"){
        readPort = '9000';
    }
    if(mode == 'auto' ){
        autoRead((data) => {
            console.log(data)
            callback(data)
        });
    }else if(mode == 'manual') {
        var websocket = new WebSocket("ws://127.0.0.1:9000/");
        websocket.onopen = function(evt) {
            websocket.send("<ReadIdCard>");
        };
        websocket.onclose = function(evt) {
        };
        websocket.onmessage = function(evt) {
            let data = "";
            data = evt.data.substr(1);
            data = data.substring(0,data.length-1);
            let info = data.trim().split(",");
            console.log(info)
            if (info[0] == "0"){
                callback(info[8]);
            } else {
                Modal.error({ title: '错误信息', content: '读卡失败，请取卡重试' })
            }
            websocket.close();
        };
        websocket.onerror = function(evt) {
            Modal.error({ title: '错误信息', content: '没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确' })
            websocket.close();
        };
    }
}

export const autoRead =(callback) =>{
    var lockReconnect = false;//避免重复连接
    var url = "ws://127.0.0.1:9000/";
    var websocket;
    var lastCardNo = "";

    createWebSocket();

    function createWebSocket() {
        websocket = new WebSocket(url)
        websocketInit();
    }

    function websocketInit(){
        // 建立 web socket 连接成功触发事件
        websocket.onopen = function(evt) {
            console.log("建立连接");
            //开启心跳检查
            heartCheck.start();
        };

        websocket.onclose = function(evt) {
            // 断开 web socket 连接成功触发事件
            console.log("连接已关闭")
            websocket.close();
        };

        // 接收服务端数据时触发事件
        websocket.onmessage = function(evt) {
            let data = "";
            data = evt.data.substr(1);
            data = data.substring(0,data.length-1);
            let info = data.trim().split(",");
            if (info[0] == "0"){
                if (!(lastCardNo === info[8])) {
                    lastCardNo = info[8];
                    callback(info[8]);
                }
            }
            heartCheck.start();
        };

        // 通信发生错误时触发
        websocket.onerror = function(evt) {
           // Modal.error({ title: '错误信息', content: '没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确' })
            websocketReconnect(url);
        };
    }

    function websocketReconnect(url) {
        if (lockReconnect) {       // 是否已经执行重连
            return;
        };
        lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多
        tt && clearTimeout(tt);
        var tt = setTimeout(function () {
            createWebSocket(url);
            lockReconnect = false;
        }, 5000);
    }

    //心跳检测
    var heartCheck = {
        timeout: 3000,
        timeoutObj: null,
        serverTimeoutObj: null,
        start: function () {
            console.log('start');
            var self = this;
            this.timeoutObj && clearTimeout(this.timeoutObj);
            this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
            this.timeoutObj = setTimeout(function () {
                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                websocket.send("<ReadIdCard>");
                self.serverTimeoutObj = setTimeout(function () {
                    websocket.close();
                }, self.timeout);

            }, this.timeout)
        }
    }
}




// WEBPACK FOOTER //
// ./components/yxxc/readCard/readBySs.js